import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SideNavStateEnum } from 'types'

interface ISideNavState {
  currentSideNavState: SideNavStateEnum
  previouseSideNavState: SideNavStateEnum
  responsiveResizingDisabled: boolean
  // to track if sideNav open/closed
  isSideNavOpen: boolean
  // to track the currently expanded nested item
  isNestedOpen: boolean
}

const initialState: ISideNavState = {
  currentSideNavState: SideNavStateEnum.Expanded,
  previouseSideNavState: SideNavStateEnum.Expanded,
  responsiveResizingDisabled: false,
  isSideNavOpen: true,
  isNestedOpen: false,
}

const sideNavSlice = createSlice({
  name: 'sideNav',
  initialState,
  reducers: {
    toggleSideNav: (state) => {
      state.responsiveResizingDisabled = true
      state.previouseSideNavState = state.currentSideNavState
      state.currentSideNavState = state.isSideNavOpen
        ? SideNavStateEnum.Shrunk
        : SideNavStateEnum.Expanded
      state.isSideNavOpen = !state.isSideNavOpen
      state.isNestedOpen = false
    },
    // for openning according to screen size
    setOpenSideNav: (state) => {
      state.isSideNavOpen = true
      state.previouseSideNavState = state.currentSideNavState
      state.currentSideNavState = SideNavStateEnum.Expanded
    },
    // for closing according to screen size
    setCloseSideNav: (state) => {
      state.isSideNavOpen = false
      state.previouseSideNavState = state.currentSideNavState
      state.currentSideNavState = SideNavStateEnum.Shrunk
    },

    // close the menu when clicking on nested icon
    setCloseSideNavFromNested: (state) => {
      if (state.previouseSideNavState === SideNavStateEnum.Shrunk) {
        state.isSideNavOpen = false
        state.previouseSideNavState = state.currentSideNavState
        state.currentSideNavState = SideNavStateEnum.Shrunk
      }
    },
    // click on nested icon
    setClickOnNestedIcon: (state) => {
      state.isSideNavOpen = true
      state.isNestedOpen = true
      state.previouseSideNavState = state.currentSideNavState
      state.currentSideNavState = SideNavStateEnum.Expanded
    },
    // click on regular icon
    setClickOnRegularIcon: (state) => {
      if (
        state.isNestedOpen &&
        state.previouseSideNavState === SideNavStateEnum.Shrunk
      ) {
        state.isSideNavOpen = false
        state.previouseSideNavState = state.currentSideNavState
        state.currentSideNavState = SideNavStateEnum.Shrunk
      }
    },
  },
})

export const {
  toggleSideNav,
  setOpenSideNav,
  setCloseSideNav,
  setCloseSideNavFromNested,
  setClickOnNestedIcon,
  setClickOnRegularIcon,
} = sideNavSlice.actions

export default sideNavSlice.reducer
